import { connect } from 'react-redux';
import { fetchDriverProperties } from '../../../../../../actions';
import { Card } from 'react-bootstrap';
import PropertyPickerVertical from './components/PropertyPickerVertical';
import BaseFeature from './BaseFeature';
import { DALI_DT8_TW_SETTINGS } from '../../../../../../utils/constantFeatures';
import { Trans } from 'react-i18next';

class DaliTW extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            isEnabled: false
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.props.fetchDriverProperties(this.props.project.id, this.props.driver.driverId);
    }

    handleChange(propertyName, value) {

        const v = value;

        this.props.handleChange(propertyName, v);
    }

    render() {

        const coldestColourTemperature = this.props.properties[DALI_DT8_TW_SETTINGS.coldestColourTemperature];
        const warmestColourTemperature = this.props.properties[DALI_DT8_TW_SETTINGS.warmestColourTemperature];
        //const powerOnColourTemperature = this.props.properties[DALI_DT8_TW_SETTINGS.powerOnColourTemperature];
        const physicalColdestColourTemperature = this.props.properties[DALI_DT8_TW_SETTINGS.physicalColdestColourTemperature];
        const physicalWarmestColourTemperature = this.props.properties[DALI_DT8_TW_SETTINGS.physicalWarmestColourTemperature];
        //const systemFailureColourTemperature = this.props.properties[DALI_DT8_TW_SETTINGS.systemFailureColourTemperature];

        return (
            <div className="flex-row">
                <Card className={this.getClassName([physicalColdestColourTemperature, physicalWarmestColourTemperature])}>
                    <div className="card-header-feature" style={{ margin: "-1rem auto 0" }}>
                        <Trans i18nKey="LED_Module_Configuration" />
                    </div>
                    <Card.Body style={{ display: "flex" }} disabled={!this.state.isEnabled}>
                        <PropertyPickerVertical
                            property={physicalColdestColourTemperature}
                            border={'border-none'}
                            title={<Trans i18nKey="Physical_Coldest" />}
                            type={"Mirek"}
                            measureUnit={physicalColdestColourTemperature.info.unit}
                            min={physicalColdestColourTemperature.valueMeta.min}
                            max={physicalColdestColourTemperature.valueMeta.max}
                            step={1}
                            handleChange={this.handleChange} />
                        <PropertyPickerVertical
                            property={physicalWarmestColourTemperature}
                            border={'border-none'}
                            title={<Trans i18nKey="Physical_Warmest" />}
                            type={"Mirek"}
                            measureUnit={physicalWarmestColourTemperature.info.unit}
                            min={physicalWarmestColourTemperature.valueMeta.min}
                            max={physicalWarmestColourTemperature.valueMeta.max}
                            step={1}
                            handleChange={this.handleChange} />
                    </Card.Body>
                </Card>

                <Card className={this.getClassName([coldestColourTemperature, warmestColourTemperature])}>
                    <div className="card-header-feature" style={{ margin: "-1rem auto 0" }}>
                        <Trans i18nKey="Colour_Temperature_Range" />
                    </div>
                    <Card.Body style={{ display: "flex" }} disabled={!this.state.isEnabled}>
                        <PropertyPickerVertical
                            property={coldestColourTemperature}
                            border={'border-none'}
                            title={<Trans i18nKey="Coldest" />}
                            type={"Mirek"}
                            measureUnit={coldestColourTemperature.info.unit}
                            min={coldestColourTemperature.valueMeta.min}
                            max={coldestColourTemperature.valueMeta.max}
                            step={1}
                            handleChange={this.handleChange} />
                        <PropertyPickerVertical
                            property={warmestColourTemperature}
                            border={'border-none'}
                            title={<Trans i18nKey="Warmest" />}
                            type={"Mirek"}
                            measureUnit={warmestColourTemperature.info.unit}
                            min={warmestColourTemperature.valueMeta.min}
                            max={warmestColourTemperature.valueMeta.max}
                            step={1}
                            handleChange={this.handleChange} />
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
    };
};

const mapDispatchToProps = {
    fetchDriverProperties
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DaliTW);
